<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Enrollment Option Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="config.title" placeholder="e.g., 10 Clock Hours"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Price" label-position="inside">
                        <b-input v-model="config.price" placeholder="0.00"></b-input>
                    </b-field>
                </div>
                <div class="column is-6">
                    <b-field label="Max Hours (0 = unlimited)" label-position="inside">
                        <b-input v-model="config.units" placeholder="0" type="number"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-6">
                    <b-field label="Enrollment Term (months, blank = no expiration)" label-position="inside">
                        <b-input v-model="config.enrollment_term_months" placeholder="e.g., 24" type="number" min="1"></b-input>
                    </b-field>
                </div>
            </div>
        </container-list-item>

        <subheader-list-item icon="fa-toggle-on" title="Enable Settings"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch v-model="config.is_enabled" :true-value="1" :false-value="0">Enabled for Enrollment</b-switch>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Enabled Date (optional)" label-position="inside">
                        <b-datetimepicker
                            v-model="config.enabled_at"
                            placeholder="Click to set..."
                            trap-focus
                            append-to-body
                            expanded
                        >
                        </b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="config.enabled_at = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Disabled Date" label-position="inside">
                        <b-datetimepicker
                            v-model="config.disabled_at"
                            placeholder="Click to set..."
                            trap-focus
                            append-to-body
                            expanded
                        >
                        </b-datetimepicker>
                        <p class="control">
                            <b-button type="is-warning" outlined @click="config.disabled_at = null"><i class="fas fa-times ml-1 mr-1"></i></b-button>
                        </p>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field>
                        <b-switch v-model="config.is_hidden" :true-value="1" :false-value="0">Hidden from enrollment dropdown</b-switch>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    export default {
        name: 'CourseConfigForm',
        props: {
            config: {
                type: Object,
                required: true
            }
        },
        components: {ContainerListItem, SubheaderListItem, CardList}
    };
</script>
